<template>
    <div>
        <div class="col-md-4 col-sm-5 mt-3 p-2  font-weight-bold titleBlock" v-if="header">
            {{header}}
        </div> 
        <ul class="list-unstyled" :class="{ topBorder: header }">
            <div class="media" v-for="(data,index) in posts" :key="index">
                <img v-bind:src="data.image" class="col-lg-3 col-12 pr-0 d-flex align-self-start" width="64" height="auto" :alt="data.title" v-if="data.image"/>     
                <div class="media-body col-12 align-self-end">
                    <h5 class="mt-0 mb-1 col-12">{{data.title}}</h5>
                    <b class="d-block col-12" >{{data.head}}</b>
                    <p class="col-12 mb-0 text-justify" v-html="$options.filters.decoder(data.body)"></p>
                    <a :href="data.url"><b class="text-right d-block lees">Lees meer</b></a>
                </div>
            </div> 
        </ul>
        <div class="row justify-content-end">
            <div class="col-md-4 col-sm-5 p-2 mb-3 titleBlockBottom" v-if="button">
                <a :href="button.url" class="no-underline" v-html="button.text">{{ button.text }}</a> 
            </div>
        </div>
    </div>
</template>

<script> 
    export default {
        name:"media",
        props:{
            header:{
                type: String,
            },
            posts:{
                required:true
            },
            button:{
                type: Object
            }
        },
        data(){
            return {

            }
        },
        method:{

        },
        filters:{
            decoder : function(value){
                if (!value) return ''
                return window.atob(value);
            }
        }
    }
</script>

<style scoped>

    .topBorder {
        border-top:2px solid black;
        padding: 20px 0px;
    }
    .media{
        border-bottom:2px solid gray;
        margin-bottom:10px;
    }
    .media .li{
        padding-left: 0px;
    }
    .media h5{
        font-weight: bold;
        margin-top: -4px !important;
    }
    .media b{
        font-size: small;
    }
    .media p{
        font-size: small;
        font-weight: 500;
    }
    .media img{
        margin-bottom:10px;
        padding-left: 0px;
        max-width: 150px;
        width: auto !important;
    }

    @media (max-width:992px){
       
    } 
 
    @media (max-width:768px){
        
    }


    @media (max-width:576px){
        .media{
            display: block;
        }
        .media img{
            max-width: 50%;
            max-height: 260px;
            width: 100%;
        }
        .media-body{
            padding: 10px 0px;
            flex: 1 0 100%;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/overall_layouts/media-items.vue